import PageHeading from 'elements/PageHeading';
import Pattern from 'elements/Pattern';
import { useAuth } from 'providers/AuthProvider';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
    DIGITAL_ATTENDANCE_HEIGHT_REQUEST,
    getDigitalAttendanceHeight,
    getDigitalAttendanceOrigin
} from 'utils/digitalAttendanceIframe';

const digitalAttendanceUrl = process.env.REACT_APP_DIGITAL_ATTENDANCE_URL
    || 'https://www.furgediak.hu/digitalisjelenletiiv/';

export default function DigitalAttendancePage() {
    const { token } = useAuth();
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState(null);
    const iframeSrc = token
        ? `${digitalAttendanceUrl}?token=${encodeURIComponent(token)}`
        : null;
    const iframeOrigin = useMemo(
        () => getDigitalAttendanceOrigin(digitalAttendanceUrl, window.location.href),
        []
    );

    useEffect(() => {
        const handleHeightMessage = (event) => {
            const height = getDigitalAttendanceHeight(
                event,
                iframeRef.current?.contentWindow,
                iframeOrigin
            );

            if (height === null) return;
            setIframeHeight((currentHeight) => (
                currentHeight !== null && Math.abs(currentHeight - height) < 2
                    ? currentHeight
                    : height
            ));
        };

        window.addEventListener('message', handleHeightMessage);
        return () => window.removeEventListener('message', handleHeightMessage);
    }, [iframeOrigin]);

    useEffect(() => {
        setIframeHeight(null);
    }, [iframeSrc]);

    const requestIframeHeight = useCallback(() => {
        if (!iframeOrigin) return;
        iframeRef.current?.contentWindow?.postMessage(
            { type: DIGITAL_ATTENDANCE_HEIGHT_REQUEST },
            iframeOrigin
        );
    }, [iframeOrigin]);

    return (
        <div className="relative flex min-h-screen w-full flex-col items-center overflow-hidden gradient-green px-site py-site">
            <Pattern className="pointer-events-none opacity-60" />

            <div className="relative z-10 flex w-full max-w-boxed flex-col gap-8">
                <PageHeading
                    title="Digitális jelenléti íveim"
                    subTitle="Itt éred el a munkáidhoz tartozó digitális jelenléti íveket és rögzített jelenléti adataidat."
                    align="left"
                    mobileAlign="center"
                />

                {iframeSrc && (
                    <iframe
                        ref={iframeRef}
                        src={iframeSrc}
                        className="block w-full overflow-hidden rounded-3xl bg-transparent shadow-2xl transition-[height] duration-200 ease-out motion-reduce:transition-none"
                        style={{ height: iframeHeight === null ? '75dvh' : `${iframeHeight}px` }}
                        scrolling={iframeHeight === null ? 'auto' : 'no'}
                        onLoad={requestIframeHeight}
                        title="Digitális jelenléti ívek"
                        allowFullScreen
                    ></iframe>
                )}
            </div>
        </div>
    );
}
